import "../../index.css";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentHotspot } from "../../redux/selectors";
import { HotspotListItemPure } from "./HotspotListItemPure";
import { selectHotspot, setHighlightHotspotNumber } from "../../redux/ui/ui";

import HotspotThumbnail from "../HotspotThumbnail/HotspotThumbnail";
import { DeleteHotspot } from "./DeleteHotspot";
import { GoToHotspotCardButton } from "./GoToHotspotCardButton";
import { getVersion } from "../../util/getVersion";
import { versions } from "../../util/constants";

function HotspotListItemNormal({ name, hotspotIndex, ...rest }) {
  const version = getVersion();
  const dispatch = useDispatch();
  const currentHotspot = useSelector(getCurrentHotspot);
  const removeHighlhight = () => dispatch(setHighlightHotspotNumber(null));
  const highlightThisHotspot = () =>
    dispatch(setHighlightHotspotNumber(hotspotIndex));
  return (
    <HotspotListItemPure
      text={name}
      onClick={() => dispatch(selectHotspot({ hotspotIndex }))}
      disabled={
        version === versions.spin &&
        currentHotspot !== hotspotIndex &&
        currentHotspot !== null
      }
      thumbnail={HotspotThumbnail}
      thumbnailProps={{ hotspotIndex }}
      nextComponent={<GoToHotspotCardButton />}
      onPointerEnter={highlightThisHotspot}
      onPointerLeave={removeHighlhight}
      {...rest}
    />
  );
}

function HotspotListItemPlacing({ name, hotspotIndex, ...rest }) {
  const currentHotspot = useSelector(getCurrentHotspot);
  return (
    <HotspotListItemPure
      text={name}
      secondaryText={"(placing spots)"}
      disabled={currentHotspot !== hotspotIndex && currentHotspot !== null}
      thumbnail={"placeholder"}
      closeComponent={<DeleteHotspot />}
      {...rest}
    />
  );
}

export function HotspotListItem(props) {
  const { hotspotIndex, name = "example hotspot name" } = props;
  const currentHotspot = useSelector(getCurrentHotspot);
  return currentHotspot === hotspotIndex && getVersion() === versions.spin ? (
    <HotspotListItemPlacing name={name} hotspotIndex={hotspotIndex} />
  ) : (
    <HotspotListItemNormal name={name} hotspotIndex={hotspotIndex} />
  );
}
